import { Injectable } from "@angular/core";
import { PageBuilderAddURL } from "../page-builder/page-builder/page-builder-add/@core/page-builder-add-url.config";
import { tap } from "rxjs";
import { of, Subject } from "rxjs";
import { HttpService } from "@app/@core/services/http.service";

@Injectable({
  providedIn: 'root'
})
export class PageBuilderAddService {
    cachedData: any;
    cachedFiles: any;

constructor(
    private httpService: HttpService,
  ) {
    // This is intentional
  }


    clearCacheByKey(cacheKey: string) {
    console.log(this.cachedData[cacheKey],this.cachedData,'cachedData')
    delete this.cachedData[cacheKey];
  }
  getFormResponseAttachment(formid, responseid) {
    if (this.cachedFiles[`f-${formid}-${responseid}`]) {
      return of(this.cachedFiles[`f-${formid}-${responseid}`]);
    }
    return this.httpService
      .get(PageBuilderAddURL.EndPoints.attachment.list.replace('{formid}', formid).replace('{responseid}', responseid))
      .pipe(
        tap(response => {
          this.cachedFiles[`f-${formid}-${responseid}`] = response;
        })
      );
  }

  private refreshDocumentHistorySource = new Subject<void>();
  refreshDocumentHistory$ = this.refreshDocumentHistorySource.asObservable();
  triggerRefresh() {
    this.refreshDocumentHistorySource.next();
  }
private refreshGridSubject = new Subject<string>(); // Carries the ID of the sender
  refreshGrid$ = this.refreshGridSubject.asObservable();
  triggerGridRefresh(originId: string) {
  this.refreshGridSubject.next(originId);
}
  clearCacheForKey(key) {
    delete this.cachedData[key];
  }

  getDocumentsHistory(responseId, formId) {
    const cacheKey = `documents-${responseId}-${formId}`;
    if (this.cachedData[cacheKey]) {
      return of(this.cachedData[cacheKey]);
    }
    const url = PageBuilderAddURL.EndPoints.documents.history
      .replace('{responseid}', responseId)
      .replace('{formId}', formId);
    return this.httpService.get(url).pipe(tap(response => (this.cachedData[cacheKey] = response)));
  }
  getMember(id, pageId) {
    return this.httpService.get(
      `${PageBuilderAddURL.EndPoints.page_config.getMember.replace('{id}', id).replace('{pageId}', pageId)}`
    );
  }
  deleteFormResponseAttachment(fileid) {
    return this.httpService.delete(PageBuilderAddURL.EndPoints.attachment.delete.replace('{fileid}', fileid));
  }
  deleteRow(id, pageId) {
    return this.httpService.delete(
      `${PageBuilderAddURL.EndPoints.page_config.deleteRow.replace('{id}', id).replace('{pageId}', pageId)}`
    );
  }
  getGridResult(pageid: string, query: string, fieldName: string = '', withResult = false) {
    const cacheKey = window.btoa(query + '-' + fieldName);
    const payload = {
      query
    };
    let url = `${PageBuilderAddURL.EndPoints.page_config.gridPageResult.replace('{id}', pageid)}`;
    if (withResult) {
      url += '?withResult=true';
    }
    return this.httpService.post(url, payload);
  }
  getFormPage(pageid: string) {
    return this.httpService.get(`${PageBuilderAddURL.EndPoints.page_config.formPage.replace('{id}', pageid)}`);
  }
  clearCacheFileByKey(key:any){
    delete this.cachedFiles[key];
  }
  updateNestedForm(requestData: any, id: number) {
    return this.httpService.patch(
      PageBuilderAddURL.EndPoints.assessments.updateNestedFormResponse.replace('{formId}', id.toString()),
      requestData
    );
  }
  submitNestedForm(formData: any) {
    return this.httpService.post(PageBuilderAddURL.EndPoints.assessments.createNestedFormResponse, formData);
  }
  editForm(formData: any, id) {
    return this.httpService.patch(
      `${PageBuilderAddURL.EndPoints.page_config.updateForm.replace('{id}', id)}`,
      formData
    );
  }
  softDeleteFormResponse(id: any, pageId: any) {
    return this.httpService.patch(
      PageBuilderAddURL.EndPoints.page_config.softDeleteRow
        .replace('{pageId}', String(pageId))
        .replace('{id}', String(id)),
      {}
    );
  }
  submitForm(formData: any) {
    return this.httpService.post(`${PageBuilderAddURL.EndPoints.page_config.submitForm}`, formData);
  }
  createFormResponseAttachment(data) {
      return this.httpService.post(PageBuilderAddURL.EndPoints.attachment.createAttachment, data);
  }

  markDocumentDeficient(body: any) {
    return this.httpService.post('/application-flow/notes/mark-deficient', body);
  }

  post(endPoint, body) {
    return this.httpService.post(endPoint,body);
  }
}
